import TableBase from './base';

export default class TableFilterable extends TableBase {

  constructor(wrapper_block_selector, lang) {

    super('.dynamic_block', lang);

    this._wrapper_block = $(wrapper_block_selector);
    this._filter_form_wrapper_selector = '.filter_form_wrapper';
    this._filter_form_display_button_selector = '.filter_form_display_button';
    this._filter_form_show_optional_filters_selector = '.filter_form_show_optional_filters';
    this._filter_form_optional_filter_row_selector = '.optional_filter_row';
    this._filter_form_selector = '.filter_form';
    this._filter_form_submit_button_selector = '.filter_form_submit_button';
    this._filter_form_reset_button_selector = '.filter_form_reset_button';
    this._filter_url_args_selector = 'input[name=filter_url_args]';
    this._filter_default_url_args_selector = 'input[name=filter_default_url_args]';
    this._status_messages_selector = '.success, .warning, .error, .attention';
    this._enter_key_code = 13;

    this._initial_url_args = this.filter_url_args;
  }

  get wrapper_block() {
    return this._wrapper_block;
  }

  get dynamic_block() {
    return this.wrapper_block.find(this._dynamic_block_selector);
  }

  get filter_form_wrapper() {
    return this.wrapper_block.find(this._filter_form_wrapper_selector);
  }

  get filter_form_display_button() {
    return this.filter_form_wrapper.find(this._filter_form_display_button_selector);
  }

  get filter_form_show_optional_filters_button() {
    return this.filter_form_wrapper.find(this._filter_form_show_optional_filters_selector);
  }

  get filter_form_optional_filter_rows() {
    return this.filter_form_wrapper.find(this._filter_form_optional_filter_row_selector);
  }

  get filter_form() {
    return this.filter_form_wrapper.find(this._filter_form_selector);
  }

  get apply_filter_url() {
    return this.filter_form.attr('action');
  }

  get refresh_table_url() {
    return this.controller_url + '/refreshTable';
  }

  get controller_url() {
    var action_slash_position = this.apply_filter_url.lastIndexOf('/');
    return this.apply_filter_url.substr(0, action_slash_position);
  }

  get filter_form_inputs() {
    return this.filter_form.find('input');
  }

  get filter_form_submit_button() {
    return this.filter_form_wrapper.find(this._filter_form_submit_button_selector);
  }

  get filter_form_reset_button() {
    return this.filter_form_wrapper.find(this._filter_form_reset_button_selector);
  }

  get filter_url_args() {
    return this.dynamic_block.find(this._filter_url_args_selector).val()
  }

  get filter_default_url_args() {
    return this.dynamic_block.find(this._filter_default_url_args_selector).val()
  }

  get initial_url_args() {
    return this._initial_url_args;
  }

  get filter_form_inputs() {

    var all_inputs_selectors = [
      'input[type=hidden]',
      'input[type=text]',
      'input[type=number]',
      'input[type=checkbox]',
      'input[type=radio]',
      'textarea'
    ];

    var all_inputs_selector = all_inputs_selectors.join(", ");

    return this.filter_form.find(all_inputs_selector);
  }

  init() {
    super.init();
    this._initDateTimeInputs();
    this._initPhoneInputs();
    this._initFilterFormVisibility();
    this._initFilterFormDisplayButton();
    this._initFilterFormDisplayOptionalFiltersButton();
    this._initOptionalFilterRows();
    this._initFilterFormSubmitButton();
    this._initFilterFormResetButton();
    this._initFilterFormDefaultValues();
    this._initFilterFormInputsHotKeys();
  };

  refresh() {
    this._sendFilterDataToUrl(
      this._getCurrentFiltersFromUrlArgs(),
      this.refresh_table_url
    );
  }

  _initDateTimeInputs() {
    this.wrapper_block.find('.date').datepicker();
    this.wrapper_block.find('.time').timepicker();
    this.wrapper_block.find('.datetime').datetimepicker().change(function() {
      $(this.parentNode).find('.error').html('');
    });
  };

  _initPhoneInputs() {

    this.wrapper_block.find('input.phone').each(function() {

      $(this).mask("+7? (999) 999-99-99");

      $(this).blur(function() {

        if($(this).val() === '+7') {
          $(this).val('');
        }

      });
    });
  }

  _initFilterFormDefaultValues() {
    this._saveFormDefaultValues(this.filter_form);
  }

  _saveFormDefaultValues(form) {

    $('[type=checkbox], [type=radio]', form).each(function() {
        $(this).prop('initial', $(this).is(':checked'));
    });

    $('[type=text], [type=number], [type=hidden], textarea', form).each(function() {
      $(this).prop('initial', $(this).val());
    });

    $('select', form).each(function() {
        $(this).prop('initial', this.selectedIndex);
    });
  }

  _resetFilterFormDefaultValues() {
    this._resetFormDefaultValues(this.filter_form);
  }

  _resetFormDefaultValues(form) {

    var table = this;

    $('[type=checkbox], [type=radio]', form).each(function() {

      $(this).prop('checked', false);

      if(table._getElementDefaultValue(this)) {
        $(this).prop('checked', true);
      }
    });

    $('[type=text], [type=number], [type=hidden], textarea', form).each(function() {
      $(this).val(table._getElementDefaultValue(this));
    });

    $('select', form).each(function() {
      this.selectedIndex = table._getElementDefaultValue(this);
    });
  }

  _getElementDefaultValue(element) {

    if($(element).data('checked_by_default') !== undefined) {
      return $(element).data('checked_by_default') === 'checked';
    }

    return $(element).data('default') !== undefined ?
      $(element).data('default') : $(element).prop('initial');
  }

  _initFilterFormVisibility() {

    if(parseInt(this.filter_form.data('default_visibility')) == 1) {
      this.filter_form.show();
      return;
    }

    this.filter_form.hide();
  }

  _initFilterFormDisplayButton() {

    var filered_table = this;

    this.filter_form_display_button.click(function () {
      filered_table.filter_form.toggle();
      filered_table._initFilterFormDisplayButtonText();
    });

    this._initFilterFormDisplayButtonText();
  };

  _initFilterFormDisplayButtonText() {

      if (this.filter_form.css('display') === "none") {
      this.filter_form_display_button.html(this.lang.getText('button_show_filter'));
      return;
    }

    this.filter_form_display_button.html(this.lang.getText('button_hide_filter'));
  }

  _initFilterFormDisplayOptionalFiltersButton() {

    var filered_table = this;

    this.filter_form_show_optional_filters_button.click(function () {
      filered_table.filter_form_optional_filter_rows.toggle();
      filered_table._initFilterFormDisplayOptionalFiltersButtonText();
    });
  };

  _initFilterFormDisplayOptionalFiltersButtonText() {

      if (this.filter_form_optional_filter_rows.css('display') === "none") {
      this.filter_form_show_optional_filters_button.html(this.lang.getText('button_show_optional_filters'));
      return;
    }

    this.filter_form_show_optional_filters_button.html(this.lang.getText('button_hide_optional_filters'));
  }

  _initOptionalFilterRows() {
    this.filter_form_optional_filter_rows.hide();
  }

  _initFilterFormSubmitButton() {

    var table = this;

    this.filter_form_submit_button.click(function (event) {
      event.preventDefault();
      table._submitFilterForm();
      return false;
    });
  };

  _submitFilterForm(use_initial_filters = false) {

    this._sendFilterDataToUrl(
      this._buildFilterFormData(use_initial_filters),
      this.apply_filter_url
    );
  };

  _sendFilterDataToUrl(filter_data, url) {

      $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: filter_data,
      beforeSend: this.showLoadingBlock.bind(this),
      success: this._processFilterSubmitResult.bind(this),
      complete: this.hideLoadingBlock.bind(this)
    });
  }

  _buildFilterFormData(use_default_filters) {

    if(use_default_filters) {
      return this._getDefaultFiltersFromUrlArgs();
    }

    var sort_filters = this._getCurrentFiltersFromUrlArgs();
    var filter_data = this._getFilterFormData();

    return $.extend(sort_filters, filter_data);
  }

  _convertBoolToInt(boolean_value) {
    return boolean_value ? 1 : 0;
  }

  _getCurrentFiltersFromUrlArgs() {
    return this._convertUrlArgsStrToObject(this.filter_url_args);
  };

  _getDefaultFiltersFromUrlArgs() {

    var default_url_args = this.filter_default_url_args ?
      this.filter_default_url_args : this.initial_url_args;

    return this._convertUrlArgsStrToObject(default_url_args);
  };

  _convertUrlArgsStrToObject(url_args_str) {

    var result_object = {};
    var pairs = url_args_str.split('&');

    for (var i = 0; i < pairs.length; i++) {

      if(!pairs[i]) {
        continue;
      }

      var pair = pairs[i].split('=');
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);

      if(result_object.hasOwnProperty(key) && $.isArray(result_object[key])) {
        result_object[key].push(value);
        continue;
      }

      if(result_object.hasOwnProperty(key)) {
        result_object[key] = [result_object[key], value];
        continue;
      }

      result_object[key] = value;
    }

    return result_object;
  }

  _getFilterFormData() {
    return this._getFormInputsDataAsObject(this.filter_form_inputs);
  };

  _getFormInputsDataAsObject(form_inputs, field_name_attr = 'name') {

    var table = this;
    var form_data_object = {};

    $(form_inputs).each(function(index, input) {

      let input_object = $(input);
      let input_type = $(input).attr('type');
      let input_name = input_object.attr(field_name_attr);
      let input_value = input_object.val();

      switch (input_type) {
        case 'checkbox':
          form_data_object = table._addFilterCheckboxInputValue(
            form_data_object, input_object, input_name, input_value
          );
          break;
        case 'radio':
          form_data_object = table._addFilterRadioInputValue(
            form_data_object, input_object, input_name, input_value
          );
          break;
        default:
          form_data_object[input_name] = input_value;
          break;
      }
    });

    return form_data_object;
  }

  _addFilterCheckboxInputValue(form_data_object, input_object, input_name, input_value) {

    if(!form_data_object.hasOwnProperty(input_name)) {
      form_data_object[input_name] = [];
    }

    if(input_object.is(':checked')) {
      form_data_object[input_name].push(input_value);
    }

    return form_data_object;
  }

  _addFilterRadioInputValue(form_data_object, input_object, input_name, input_value) {

    if(!form_data_object.hasOwnProperty(input_name)) {
      form_data_object[input_name] = '';
    }

    if(input_object.is(':checked')) {
      form_data_object[input_name] = input_value;
    }

    return form_data_object;
  }

  _processFilterSubmitResult(result) {

    this._resetStatusMessages();

    if (!parseInt(result.status)) {
      this._processFilterFormSubmitWrongResult(result);
      return;
    }

    this._processFilterFormSubmitSuccessResult(result);
  }

  _resetStatusMessages(wrapper = this.wrapper_block) {
    var messages = this._getStatusMessages(wrapper);
    messages.html('');
    messages.hide();
  }

  _getStatusMessages(wrapper = this.wrapper_block) {
    return $(wrapper).find(this._status_messages_selector);
  }

  _processFilterFormSubmitWrongResult(result) {
    this._processFormSubmitWrongResult(this.filter_form, result);
  }

  _processFormSubmitWrongResult(form, result) {

    if (result.hasOwnProperty('errors')) {
      this._showFormValidationErrors(form, result.errors);
      return;
    }

    this._processWrongResult(result);
  };

  _showFormValidationErrors(form, errors) {

    if (errors.hasOwnProperty('form')) {
      this._showFormWarning(form, errors.form);
    }

    if (errors.hasOwnProperty('fields')) {
      this._showFormFieldErrors(form, errors.fields);
    }
  };

  _showFormWarning(form, form_warnings) {
    let filter_form_warning_block = form.find(this._getFormWarningBlockSelector());
    filter_form_warning_block.html(form_warnings.join("<br/>"));
    filter_form_warning_block.show();
  }

  _getFormWarningBlockSelector() {
    return '.form_warning';
  }

  _showFormFieldErrors(form, field_errors) {

    var table = this;

    $.each(field_errors, function (field, error_text) {
      let error_block_selector = table._buildFormFieldErrorBlockSelector(field);
      let field_error_block = form.find(error_block_selector);
      field_error_block.html(error_text);
      field_error_block.show();
    });
  }

  _buildFormFieldErrorBlockSelector(form_field) {
    return '.error_' + form_field;
  }

  _processFilterFormSubmitSuccessResult(result) {
    this._initFilterFormVisibility();
    this._initFilterFormDisplayButtonText();
    this._reinitDynamicBlock(result.html);
  }

  _initFilterFormResetButton() {
    this.filter_form_reset_button.click(this._resetFilterForm.bind(this));
  };

  _resetFilterForm() {
    this._resetFilterFormDefaultValues();
    this._submitFilterForm(true);
    this._initFilterFormVisibility();
    this._initFilterFormDisplayButtonText();
  }

  _initFilterFormInputsHotKeys() {

    var table = this;

    this.filter_form_inputs.keyup(function (e) {
      if (e.which === table._enter_key_code) {
        table._submitFilterForm();
        return false;
      }
    });
  }

  _addFilterUrlArgs(base_url) {
    return base_url + this.filter_url_args;
  };
}



/** WEBPACK FOOTER **
 ** ./src/common/table/filterable.js
 **/